export default {
    cardTitle: {
      margin: "20px 0px 0px 0px"
    },
    
    cardButton: {
      border: "none",
      outline: "none",
      backgroundColor: "inherit",
      color: "#215DAA",
      display: "inline-block",
      padding: "0px",
      marginTop: "auto"
    }
  };
  